import { CozyCardIllustrationOptions } from './CozyCardIllustrationOptions';
//@ts-expect-error untyped
import bottomPanelIllustration from 'bender-url!crm-pipeline-board-settings-lib/images/avatar_illustration.svg';
//@ts-expect-error untyped
import compactIllustration from 'bender-url!crm-pipeline-board-settings-lib/images/compact_illustration.svg';
//@ts-expect-error untyped
import defaultIllustration from 'bender-url!crm-pipeline-board-settings-lib/images/default_illustration.svg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { getHasAssociationsAndPriority } from '../utils/getHasAssociationsAndPriority';
import { useCallback } from 'react';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CozyCardPreferences = () => {
  const {
    settings,
    updateDraft,
    hasTags,
    objectTypeId
  } = useBoardPanelPresentationContext();
  const isAssociationsAndPriorityVisible = getHasAssociationsAndPriority(objectTypeId);
  const showTagSettings = hasTags;
  const handleCardStyleChange = useCallback(v => () => {
    updateDraft({
      cozyCardPreferences: Object.assign({}, settings.cozyCardPreferences, {
        isCompact: v
      })
    });
  }, [updateDraft, settings]);
  const onChangeAssociationsAndPriority = useCallback(evt => {
    updateDraft({
      cozyCardPreferences: Object.assign({}, settings.cozyCardPreferences, {
        isBottomPanelHidden: !evt.target.checked
      })
    });
  }, [updateDraft, settings]);
  const onChangeTagSetting = useCallback(evt => {
    updateDraft({
      cozyCardPreferences: Object.assign({}, settings.cozyCardPreferences, {
        areTagsHidden: !evt.target.checked
      })
    });
  }, [updateDraft, settings]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.cozyCardsSection.header"
      })
    }), /*#__PURE__*/_jsx(CozyCardIllustrationOptions, {
      options: [{
        illustration: defaultIllustration,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editCardsPanel.cozyCardsSection.options.defaultOption"
        }),
        selected: !settings.cozyCardPreferences.isCompact,
        onSelect: handleCardStyleChange(false),
        key: 'default-option',
        testSelector: 'cozy-cards-radio-default'
      }, {
        illustration: compactIllustration,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editCardsPanel.cozyCardsSection.options.cozy"
        }),
        selected: settings.cozyCardPreferences.isCompact,
        onSelect: handleCardStyleChange(true),
        key: 'cozy-option',
        testSelector: 'cozy-cards-radio-cozy'
      }]
    }), isAssociationsAndPriorityVisible && /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "bottom-panel-is-shown-input",
      onChange: onChangeAssociationsAndPriority,
      checked: !settings.cozyCardPreferences.isBottomPanelHidden,
      children: /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        title: /*#__PURE__*/_jsx(Image, {
          src: bottomPanelIllustration,
          role: "img"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editCardsPanel.cozyCardsSection.bottomPanel.description"
        })
      })
    }), showTagSettings && /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "deal-label-settings",
      onChange: onChangeTagSetting,
      checked: !settings.cozyCardPreferences.areTagsHidden,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.cozyCardsSection.labels.description"
      })
    })]
  });
};